import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  VISIT_STATUS_NEW,
  VISIT_STATUS_STARTED,
  VISIT_STATUS_COMPLETED,
  VisitStatus,
  VISIT_STATUS_CANCELLED,
} from "@/schemas/contractorVisit";
import {
  CircleCheckBigIcon,
  CircleOffIcon,
  ClockIcon,
  ClockPlusIcon,
} from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface ContractorVisitStatusBadgeProps {
  status: VisitStatus;
}

export const ContractorVisitStatusBadge = ({
  status,
}: ContractorVisitStatusBadgeProps) => {
  const { t } = useTranslation();

  const Icon = useMemo(() => {
    switch (status) {
      case VISIT_STATUS_NEW:
        return ClockPlusIcon;
      case VISIT_STATUS_STARTED:
        return ClockIcon;
      case VISIT_STATUS_COMPLETED:
        return CircleCheckBigIcon;
      case VISIT_STATUS_CANCELLED:
        return CircleOffIcon;
      default:
        return ClockIcon;
    }
  }, [status]);

  return (
    <Badge
      className={cn("text-xs", {
        "bg-sky-500 hover:bg-sky-500": status === VISIT_STATUS_NEW,
        "bg-cyan-500 hover:bg-cyan-500": status === VISIT_STATUS_STARTED,
        "bg-green-700 hover:bg-green-700": status === VISIT_STATUS_COMPLETED,
        "bg-red-700 hover:bg-red-700": status === VISIT_STATUS_CANCELLED,
      })}
    >
      <Icon className="w-4 h-4 mr-1" />
      {t(`contractorVisitsStatuses.${status}`)}
    </Badge>
  );
};
